import {
	useEffect
}from "react"
import {
	Form, Modal, Popconfirm
}from "antd"
import CustomButton from "../../components/CustomButton"
import {
	useSelector
}from "react-redux"
import CustomUpload from "../../components/CustomUpload"

const AddReInfoOrgByFile = ({ visible, setVisible, getExampleFile, getFile, upload }) => {
	const { isSending, changed } = useSelector(state => state.reInfoOrgReducer)

	const [form] = Form.useForm()

	useEffect(() => {
		if (changed)
			handleCancel()
	}, [changed])

	const uploadOrgFile = () => {
		form.validateFields().then(values => {
			const data = new FormData()
			values.file?.forEach((src) => {
				data.append("File", src.originFileObj)
			})
			upload(data)
		})
	}

	const handleCancel = () => {
		setVisible(false)
		form.resetFields()
	}

	const normFile = (e) => {
		if (Array.isArray(e))
		  return e
		return e?.fileList
	  }

	return (
		<Modal
			className="mat-character"
			footer={ (
				<Popconfirm
					cancelText="Нет"
					okText="Да"
					placement="left"
					title="Внимание! Организации, отсутствующие в файле, но присутствующие в перечне, будут удалены из него, а их строительные материалы будут удалены из номенклатуры. Вы уверены, что хотите загрузить файл?"
					onCancel={ (e) => {
						e.preventDefault()
						return null
					} }
					onConfirm={ (e) => {
						e.preventDefault()
						uploadOrgFile()
					} }
				>
					<CustomButton
						className="save-btn"
						loading={ isSending }
					>
					Сохранить
					</CustomButton>
				</Popconfirm>

			) }
			title="Добавление организаций"
			visible={ visible }
			width={ 1000 }
			onCancel={ handleCancel }
		>
			<Form
				className="mat-character-form"
				form={ form }
			>
				<Form.Item>
					<CustomButton
						loading={ isSending }
						onClick={ () => {
							getExampleFile()
						} }
					>
            Выгрузить шаблон файла для заполнения
					</CustomButton>
				</Form.Item>
				<Form.Item>
					<CustomButton
						loading={ isSending }
						onClick={ () => {
							getFile()
						} }
					>
            Выгрузить перечень актуальных организаций
					</CustomButton>
				</Form.Item>
				<Form.Item
					getValueFromEvent={ normFile }
					label="Загрузочный файл"
					name="file"
					rules={ [
						{ required : true,
							message  : "Пожалуйста, добавьте файл!" }
					] }
					valuePropName="fileList"
				>
					<CustomUpload
						isExcel
						maxCount={ 1 }
					/>
				</Form.Item>
			</Form>
		</Modal>
	)
}

export default AddReInfoOrgByFile